import React from 'react';
import { Field } from 'react-final-form';
import Select from 'react-select';
import { ValidationError } from '../../components';
import css from './FieldReactSelect.module.css';

/* const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? 'var(--marketplaceColor)' : 'var(--colorGrey100)',
    boxShadow: state.isFocused ? '0 0 0 3px var(--marketplaceColorLight)' : 'none',
    '&:hover': {
      borderColor: 'var(--marketplaceColor)',
    },
    minHeight: '48px',
    marginBottom: '18px',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? 'var(--marketplaceColor)' : state.isFocused ? 'var(--marketplaceColorLight)' : 'white',
    color: state.isSelected ? 'white' : 'var(--colorGrey700)',
    cursor: 'pointer',
    '&:active': {
      backgroundColor: 'var(--marketplaceColor)',
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: 'var(--marketplaceColorLight)',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: 'var(--marketplaceColor)',
    fontWeight: '600',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: 'var(--marketplaceColor)',
    '&:hover': {
      backgroundColor: 'var(--marketplaceColor)',
      color: 'white',
    },
  }),
}; */

const customStyles = {};

const FieldReactSelectComponent = props => {
  const { className, id, label, input, meta, options, ...rest } = props;

  const { touched, error } = meta;
  const hasError = touched && error;

  const transformedOptions = options.map(option => ({
    value: option.id.uuid,
    label: option.attributes.profile.displayName,
    data: option,
  }));

  const value = input.value
    ? transformedOptions.filter(option => input.value.includes(option.value))
    : [];

  const handleChange = selectedOptions => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    input.onChange(selectedValues);
  };

  return (
    <div className={className}>
      {label ? (
        <label htmlFor={id} className={css.label}>
          {label}
        </label>
      ) : null}
      <Select
        {...rest}
        id={id}
        name={input.name}
        value={value}
        onChange={handleChange}
        options={transformedOptions}
        isMulti
        styles={customStyles}
        className={css.select}
        placeholder="Search and select stores..."
      />
      <ValidationError fieldMeta={meta} />
    </div>
  );
};

const FieldReactSelect = props => {
  return <Field component={FieldReactSelectComponent} {...props} />;
};

export default FieldReactSelect;
